import useGetInfiniteFaq from '@/hooks/faq/useGetInfiniteFaq';
import useCustomRouter from '@/hooks/useCustomRouter';
import { ROUTES } from '@/types/common';
import { MagazineLineItemVo } from '@/types/magazine';

interface useFaqViewModel {
  faqs: Array<MagazineLineItemVo>;
  isFaqsLoading: boolean;
  hasFaqsNextPage?: boolean;
  fetchFaqsNextPage: () => void;
  onClickFaqDetail: (faqPid: string) => void;
}
const useFaqViewModel = (): useFaqViewModel => {
  const { moveToPage } = useCustomRouter();
  const { faqs, isFaqsLoading, hasFaqsNextPage, fetchFaqsNextPage } =
    useGetInfiniteFaq();

  const onClickFaqDetail = (faqPid: string) => {
    moveToPage({
      webLink: `${ROUTES.FAQ.DETAIL.path}/${faqPid}`,
      mobileScreenName: ROUTES.FAQ.DETAIL.appScreenName,
      params: {
        id: faqPid,
      },
    });
  };

  return {
    faqs,
    isFaqsLoading,
    hasFaqsNextPage,
    fetchFaqsNextPage,
    onClickFaqDetail,
  };
};

export default useFaqViewModel;
